export const NAMESPACE = 'mvx';
export const MVXICONCOLOR = '#e83746';
export const MAX_COLUMNS = 5;
export const MIN_COLUMNS = 1;
export const DEFAULT_COLUMNS =  3;
export const MAX_ROWS = 5;
export const MIN_ROWS = 1;
export const DEFAULT_ROWS = 1;
